<template>
  <div class="container">
    <div v-if="typeControlPermission">    
      <div v-if="JSON.stringify(obj) !== '{}'">
        <b-card
          header="共管人設定"
          header-border-variant="white"
          header-bg-variant="light"
          footer-bg-variant="light"
          body-border-variant="white"        
          class="card-3"
        >
          <b-card-body>
            <div 
              id="style-3" 
              style="height:580px; padding:5px 0px 5px 0px; overflow-x:hidden; overflow-y:visible;"
            >
              <div class="text-center">
                <a-row type="flex">
                  <a-col 
                    :span="4" 
                    :offset="1" 
                    v-for="data in items.data" 
                    :key="data.id"
                  >
                    <a-popover title="權限表">
                      <template slot="content">
                        <div 
                          id="style-3" 
                          style="height:200px; width:200px; padding:0px 0px 0px 0px; overflow-x:hidden; overflow-y:visible;"
                        >
                        <ol style="list-style: none; padding: 0;">
                          <li v-for="item in data.permissions" :key="item.id" style="margin-bottom: 16px;margin-right: 8px; border: 1px solid #ccc; border-radius: 8px; padding: 12px; background-color: #f9f9f9;">
                            <div style="font-weight: bold; font-size: 14px; color: #333; margin-bottom: 8px;">
                              <i class="fas fa-folder-open" style="margin-right: 6px;"></i>
                              {{ item.title }}
                            </div>
                            <ul v-for="obj in item.acts_detailpermission" :key="obj.id" style="padding-left: 20px; list-style-type: disc;">
                              <li style="margin: 4px 0; color: #555;">
                                <i class="fas fa-angle-right" style="margin-right: 4px;"></i>
                                {{ obj.title }}
                              </li>
                            </ul>
                          </li>
                        </ol>

                        </div>
                      </template>
                      
                      <div style="padding:5px;">                                                                                 
                        <b-avatar 
                          :src="data.pri_url" 
                          text="data.username" 
                          size="7rem" 
                          class="align-baseline"
                        />
                        <br/> 
                        <b-icon-person-square v-if="data.master == 'Y'" />                                    
                        <b-icon-person v-if="data.master == 'N'" />
                        &ensp;
                        <span 
                          style="font-size:14px; cursor:pointer;" 
                          v-if="data.master == 'Y'" 
                          @click="openPermission(data)" 
                          v-text="'(管理者)'"
                        />
                        <span 
                          style="font-size:14px;" 
                          v-else 
                          v-text="'(共管人)'"
                        /> 
                        <br/> 
                        <button 
                          type="button" 
                          @click="editors(data)" 
                          class="btn btn-light btn-sm"
                        >
                          {{ data.displayname }}
                        </button>                                                                    
                      </div>   
                    </a-popover>                          
                  </a-col>                  
                </a-row>  
              </div>                 
            </div>          
          </b-card-body>
          
          <template #footer>
            <small class="text-muted">
              <a-button-group>
                <a-button type="primary" @click="addman()">
                  <b-icon  
                    style="margin-right: 0.3rem;" 
                    scale="1.1" 
                    icon="person-plus" 
                    variant="light" 
                  />
                  新增共管人
                </a-button>
              </a-button-group>                
            </small>
          </template>        
        </b-card>
      </div>
    </div>
    
    <span v-else v-text="'您沒有管理權限'" />
    
    <!-- Loading Modal -->
    <b-modal 
      ref="my-loading" 
      id="modal-2" 
      title="Loading" 
      @hide="onHide" 
      centered 
      hide-footer 
      hide-header
    >
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered" />
        <strong>Loading....</strong>
      </div>
    </b-modal> 

    <!-- 新增共管人 Modal -->
    <b-modal 
      ref="my-loadingx" 
      id="modal-x" 
      size="lg" 
      title="Loading" 
      @hide="onHide" 
      centered 
      hide-footer 
      hide-header
    >
      <div class="text-center">
        <div class="text-center">  
          <p class="h6">
            <b-icon-vinyl-fill />
            人員清單
          </p> 
          <a-steps :current="current" :size="sizes">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
          </a-steps>                                           
        </div>  
        
        <div v-if="current == 0" class="text-left">
          <a-input-search 
            placeholder="請輸入查詢名稱" 
            style="margin: 10px; width: 200px" 
            enter-button 
            @search="onSearch" 
          /> 
        </div>      
         
        <div 
          class="overflow-auto" 
          style="height: 485px; width:100%;" 
          id="style-3"
        >                    
          <div class="steps-content">                      
            <!-- 步驟一：選擇人員 -->
            <a-table 
              v-if="current == 0"
              :columns="mcolumns"
              :row-key="record => record.id"
              :data-source="udata"
              :pagination="upagination"
              :loading="uloading"
              :row-selection="{ 
                type:'radio',
                selectedRowKeys: selectedRowKeys, 
                onChange: onSelectChange 
              }"
              :customRow="record => ({ on: { click: () => onSelectChange([record.id]) } })"
              @change="uhandleTableChange"
              :row-class-name="checkrow"
              bordered
            >                                                
              <template slot="pri_url" slot-scope="pri_url"> 
                <b-avatar 
                  :src="pri_url" 
                  variant="primary" 
                  text="" 
                  size="2.5rem" 
                  class="align-baseline"
                />                                 
              </template> 
              
              <template slot="username" slot-scope="record">
                <div>
                  <span 
                    v-if="record.username != ''" 
                    style="color:#F08C3C;" 
                    v-text="maskName(record.username)"
                  />                                   
                </div>
              </template> 
              
              <template slot="display_name" slot-scope="record">
                <div>
                  <span 
                    v-if="record.display_name != ''" 
                    style="color:#2c7190;" 
                    v-text="record.display_name"
                  />                                    
                </div>
              </template>                                                                                
            </a-table>
            
            <!-- 步驟二：權限設定 -->
            <div v-if="current == 1">
              <p />
              
              <!-- 權限選擇區域 -->
              <div class="permissions-container">
                <!-- 全選控制 -->
                <div class="global-controls">
                  <div class="control-header">
                    <h4>權限設定</h4>
                    <div class="global-buttons">
                      <a-button size="small" type="primary" @click="selectAll">
                        <a-icon type="check-square" />
                        全選
                      </a-button>
                      <a-button size="small" @click="clearAll">
                        <a-icon type="close-square" />
                        清除
                      </a-button>
                    </div>
                  </div>
                </div>

                <!-- 權限組別 -->
                <div 
                  class="permission-group" 
                  v-for="item in items.data[0].permissions" 
                  :key="item.id"
                >
                  <!-- 組別標題與組別控制 -->
                  <div class="group-header">
                    <div class="group-title">
                      <a-icon type="folder-open" class="group-icon" />
                      <span class="group-name">{{ item.title }}</span>
                      <a-tag size="small" color="blue">
                        {{ item.acts_detailpermission.length }} 項
                      </a-tag>
                    </div>
                    <div class="group-controls">
                      <a-button 
                        size="small" 
                        type="link" 
                        @click="selectGroup(item)"
                        :disabled="isGroupFullySelected(item)"
                      >
                        <a-icon type="check" />
                        全選此組
                      </a-button>
                      <a-button 
                        size="small" 
                        type="link" 
                        @click="clearGroup(item)"
                        :disabled="!isGroupPartiallySelected(item)"
                      >
                        <a-icon type="close" />
                        清除此組
                      </a-button>
                    </div>
                  </div>

                  <!-- 權限項目 -->
                  <div class="permissions-grid">
                    <div 
                      v-for="obj in item.acts_detailpermission" 
                      :key="obj.id"
                      class="permission-item"
                      :class="{ 'selected': isPermissionSelected(item.id, obj.id) }"
                      @click="togglePermission(item.id, obj.id)"
                    >
                      <div class="permission-checkbox">
                        <a-checkbox 
                          :checked="isPermissionSelected(item.id, obj.id)"
                          @change="togglePermission(item.id, obj.id)"
                          @click.stop
                        />
                      </div>
                      <div class="permission-content">
                        <div class="permission-title">{{ obj.title }}</div>
                        <div class="permission-description" v-if="obj.description">
                          {{ obj.description }}
                        </div>
                      </div>
                      <div class="permission-icon">
                        <a-icon 
                          :type="isPermissionSelected(item.id, obj.id) ? 'check-circle' : 'circle'" 
                          :class="{ 'selected-icon': isPermissionSelected(item.id, obj.id) }"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 選擇摘要 -->
                <div class="selection-summary" v-if="selected.length > 0">
                  <div class="summary-header">
                    <a-icon type="info-circle" />
                    <span>已選擇 {{ selected.length }} 項權限</span>
                  </div>
                  <div class="summary-tags">
                    <a-tag 
                      v-for="(tag, index) in getSelectedSummary()" 
                      :key="index"
                      closable
                      @close="removeSelectedItem(tag.value)"
                      color="blue"
                    >
                      {{ tag.label }}
                    </a-tag>
                  </div>
                </div>
              </div>                              
            </div>
            
            <!-- 步驟三：確認 -->
            <div v-if="current == 2">
              <p />                          
              <b-alert show variant="success">
                您的共管人參數設定完畢, 請按下存檔後資料將送出
              </b-alert>
            </div>
          </div>
        </div>
        
        <!-- 按鈕組 -->
        <a-button-group>
          <a-button type="dashed" @click="cancel()" :loading="loading">
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="x-circle" 
              variant="secondary" 
            />
            取消 
          </a-button>
          
          <a-button 
            v-if="current > 0" 
            type="primary" 
            :loading="loading"  
            @click="prev"
          >
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="chevron-left" 
              variant="secondary" 
            />
            上一步
          </a-button>                                
          
          <a-button 
            v-if="current < steps.length - 1"  
            :disabled="!steps[current].state"  
            type="primary" 
            @click="next"
          >
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="chevron-right" 
              variant="secondary" 
            />
            下一步
          </a-button>
          
          <a-button
            v-if="current == steps.length - 1"
            type="primary"
            @click="save()"
            :loading="loading"
          >
            <a-icon type="save" />
            存檔 
          </a-button>              
        </a-button-group>  
      </div>
    </b-modal>   

    <!-- 修改權限 Modal -->
    <b-modal 
      ref="my-loadingm" 
      id="modal-m" 
      title="Loading" 
      @hide="onHide" 
      centered 
      hide-footer 
      hide-header
    >
      <div class="text-center">       
        <div 
          class="overflow-auto" 
          style="height: 450px; width:100%;" 
          id="style-3"
        >
          <!-- 權限選擇區域 -->
          <div class="permissions-container">
            <!-- 全選控制 -->
            <div class="global-controls">
              <div class="control-header">
                <h4>修改權限設定</h4>
                <div class="global-buttons">
                  <a-button size="small" type="primary" @click="selectAllM">
                    <a-icon type="check-square" />
                    全選
                  </a-button>
                  <a-button size="small" @click="clearAllM">
                    <a-icon type="close-square" />
                    清除
                  </a-button>
                </div>
              </div>
            </div>

            <!-- 權限組別 -->
            <div 
              class="permission-group" 
              v-for="item in uitem.permissions" 
              :key="item.vals"
            >
              <!-- 組別標題與組別控制 -->
              <div class="group-header">
                <div class="group-title">
                  <a-icon type="folder-open" class="group-icon" />
                  <span class="group-name">{{ item.title }}</span>
                  <a-tag size="small" color="blue">
                    {{ item.acts_detailpermission.length }} 項
                  </a-tag>
                </div>
                <div class="group-controls">
                  <a-button 
                    size="small" 
                    type="link" 
                    @click="selectGroupM(item)"
                    :disabled="isGroupFullySelectedM(item)"
                  >
                    <a-icon type="check" />
                    全選此組
                  </a-button>
                  <a-button 
                    size="small" 
                    type="link" 
                    @click="clearGroupM(item)"
                    :disabled="!isGroupPartiallySelectedM(item)"
                  >
                    <a-icon type="close" />
                    清除此組
                  </a-button>
                </div>
              </div>

              <!-- 權限項目 -->
              <div class="permissions-grid">
                <div 
                  v-for="obj in item.acts_detailpermission" 
                  :key="obj.vals"
                  class="permission-item"
                  :class="{ 'selected': isPermissionSelectedM(item.vals, obj.vals) }"
                  @click="togglePermissionM(item.vals, obj.vals)"
                >
                  <div class="permission-checkbox">
                    <a-checkbox 
                      :checked="isPermissionSelectedM(item.vals, obj.vals)"
                      @change="togglePermissionM(item.vals, obj.vals)"
                      @click.stop
                    />
                  </div>
                  <div class="permission-content">
                    <div class="permission-title">{{ obj.title }}</div>
                    <div class="permission-description" v-if="obj.description">
                      {{ obj.description }}
                    </div>
                  </div>
                  <div class="permission-icon">
                    <a-icon 
                      :type="isPermissionSelectedM(item.vals, obj.vals) ? 'check-circle' : 'circle'" 
                      :class="{ 'selected-icon': isPermissionSelectedM(item.vals, obj.vals) }"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 選擇摘要 -->
            <div class="selection-summary" v-if="selectedm.length > 0">
              <div class="summary-header">
                <a-icon type="info-circle" />
                <span>已選擇 {{ selectedm.length }} 項權限</span>
              </div>
              <div class="summary-tags">
                <a-tag 
                  v-for="(tag, index) in getSelectedSummaryM()" 
                  :key="index"
                  closable
                  @close="removeSelectedItemM(tag.value)"
                  color="blue"
                >
                  {{ tag.label }}
                </a-tag>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 按鈕組 -->
        <a-button-group>
          <a-button type="dashed" @click="cancel2()" :loading="loading2">
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="x-circle" 
              variant="secondary" 
            />
            取消 
          </a-button>
          
          <a-button type="dashed" @click="remove()" :loading="loading2">
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="trash" 
              variant="secondary" 
            />
            刪除
          </a-button>  
          
          <a-button type="dashed" @click="save2()" :loading="loading2">                
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="arrow-repeat" 
              variant="secondary" 
            />
            更新 
          </a-button>                                              
        </a-button-group>  
      </div>
    </b-modal> 

    <!-- 管理員切換 Modal -->
    <b-modal 
      ref="my-admin" 
      id="modal-admin" 
      title="Loading"  
      @hide="onHide" 
      centered 
      hide-footer 
      hide-header
    >
      <div class="text-center">       
        <div 
          class="overflow-auto" 
          style="height: 450px; width: 100%;" 
          id="style-3"
        >
          <a-radio-group v-model="selectedValue" class="radio-group">
            <div 
              v-for="data in items.data" 
              :key="data.id" 
              :class="data.id == selectedValue ? 'cssSelected item-container' : 'cssUnSelected item-container'"
            >
              <b-avatar 
                :src="data.pri_url" 
                variant="primary" 
                text="data.username" 
                size="7rem" 
                class="align-baseline avatar"
              />
              <div class="text-container">
                <span class="displayname" v-text="data.displayname" />
                <br/>
                <a-radio-button 
                  :value="data.id" 
                  :checked="data.master === 'Y'" 
                  class="radio-button"
                >
                  選擇 
                  <b-icon icon="pencil-square" scale="1" variant="primary" />
                </a-radio-button>
              </div>
            </div>
          </a-radio-group>
        </div>
        
        <div style="padding:0.3rem;" />
        
        <!-- 按鈕組 -->
        <a-button-group>
          <a-button type="dashed" @click="cancel3()" :loading="loading2">
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="x-circle" 
              variant="secondary" 
            />
            取消 
          </a-button>                 
          
          <a-button type="dashed" @click="updateAdmin()" :loading="loading2">                
            <b-icon  
              style="margin-right: 0.3rem;" 
              scale="1.1" 
              icon="arrow-repeat" 
              variant="secondary" 
            />
            更新
          </a-button>                                              
        </a-button-group>  
      </div>
    </b-modal>         

    <!-- 成功提示 -->
    <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="success"
      dismissible
    >
      更新成功
    </b-alert>              
  </div>        
</template>

<script>
import { mapState, mapActions } from "vuex";
import { makorgService, cmessService } from '../../_services'

// API 服務函數
const queryuser = params => {
  return cmessService.findusListName(params.page, params.name)
}

const querymenber = params => {
  return makorgService.querymenber(params.id) 
};

const queryfucntion = params => {
  return makorgService.queryfucntion(params.id)
};

const postorgman = obj => {
  return makorgService.postorgman(obj)
}; 

const deleteorgman = obj => {
  return makorgService.deleteorgman(obj)
};

const updateorgman = obj => {
  return makorgService.updateorgman(obj)
};

const putOrgAdmin = obj => {
  return makorgService.putOrgAdmins(obj)
};

// 表格欄位定義
const mcolumns = [
  {
    title: '圖像',
    dataIndex: 'pri_url',
    width: '20%',    
    scopedSlots: { customRender: 'pri_url' },    
  },       
  {
    title: '註冊帳號',
    dataIndex: '',
    scopedSlots: { customRender: 'username' },      
    width: '30%',
  },   
  {
    title: 'Line顯示名稱',
    dataIndex: '',
    scopedSlots: { customRender: 'display_name' },      
    width: '30%',
  },  
];

export default {
  name: 'Partner',   

  data() {
    return {
      // 基礎資料
      funarry: [],
      orgdata: [], 
      selected: [],   
      selectedm: [],
      uitem: [], 
      usdata: {}, 
      obj: {},
      
      // 狀態控制
      showTop: false,
      loading: false,   
      loading2: false,       
      
      // 表格資料
      items: [],  
      mcolumns,  
      name: "all",
      udata: [],
      cmaster: null, 
      upagination: { defaultPageSize: 4 },  
      selectedRowKeys: [],  
      uloading: false,  
      sizes: 'small',
      selectedValue: null,
      selectedItems: null,      
      
      // 表單資料
      form: {
        id: '',
        uid: '',
        desc: '',            
        name: '',
        title: '',
        company: '',
        finkurl: '',
        iinkurl: '',
        url: '',
      }, 
      
      // 步驟控制
      current: 0,
      steps: [
        {
          title: '第一步 (選擇共管人)',
          content: 'First-content',
          state: false,
        },
        {
          title: '第二步 (設定權限)',
          content: 'Second-content',
          state: false,
        },
        {
          title: '存檔',
          content: 'Last-content',
        },
      ],                                
    };
  },

  // 生命週期
  mounted() {
    this.obj = this.datas.find(item => item.id == this.defaultval.id)
    this.inid()
  },

  // 計算屬性
  computed: {
    ...mapState("account", ["status", "user"]), 
    ...mapState("makeorg", ["datas", "defaultval"]),
    
    typeControlPermission() {
      const currentVal = this.$route.name;
      const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
      const adv = acts_permissions.find(item => item.vals === "Orgmanagement");
      if (!adv) return null;
      return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
    }    
  }, 

  // 監聽器
  watch: {
    defaultval(val) {
      this.obj = this.datas.find(item => item.id == val.id)
      this.inid()
    },
    
    selected() {
      if (this.selected.length > 0) {
        this.steps[1].state = true
      }
      if (this.selected.length == 0) {
        this.steps[1].state = false
      }
    }
  },

  // 方法
  methods: {
    ...mapActions('makeorg', ['readorgdata', 'insertorg']),      
    
    // === 初始化方法 ===
    async inid() {
      await this.fetch({ id: this.defaultval.id })
      await this.usfetch({ results: 4, page: 1, pageSize: 4, name: this.name });
    },

    // === UI 控制方法 ===
    addman() {
      this.current = 0 
      this.loading = false                        
      this.showTop = false
      this.selectedRowKeys = []
      this.selected = []
      this.steps[0].state = false
      this.steps[1].state = false      
      this.checkman()
      this.$refs['my-loadingx'].show()
    },

    // === 工具方法 ===
    maskName(name) {
      const len = name.length;
      const half = Math.ceil(len / 2);
      const maskedPart = '*'.repeat(half);
      const visiblePart = name.slice(half);
      return maskedPart + visiblePart;
    },    

    checkman() {
      if (this.items.data !== undefined && this.items.data !== null && this.udata !== null) {
        this.udata = this.udata.map(x => {                    
          if (this.items.data.find(item => item.uid == x.id)) {
            x.expanded = true; 
          } else {
            x.expanded = false; 
          }                                      
          return x;
        }); 
      }
    },

    // === 編輯方法 ===
    async editors(val) {
      let tmp = []
      this.selectedm = []   
      this.usdata = {}   
      
      if (val.master === 'Y') {
        return false
      }
      
      // 先重新載入最新資料
      await this.inid()
      
      // 從最新載入的資料中找到對應用戶
      const updatedUserData = this.items.data.find(user => user.uid === val.uid);
      
      if (updatedUserData) {
        this.uitem = this.items.data[0] // 取得最高管理員的權限
        
        // 使用最新的資料設定權限
        for (var i in updatedUserData.permissions) {
          for (var j in updatedUserData.permissions[i].acts_detailpermission) {
            tmp.push({ id: updatedUserData.permissions[i].acts_detailpermission[j].id })
            this.selectedm.push(updatedUserData.permissions[i].vals + ':' + updatedUserData.permissions[i].acts_detailpermission[j].vals)
          }
        }
        
        this.usdata = updatedUserData
        this.$refs['my-loadingm'].show()
      }
    },

    openPermission(item) {  
      const masterItem = this.items.data.find(data => data.master === 'Y');
      if (masterItem) {
        this.selectedValue = masterItem.id;
      }    
      this.selectedItems = item
      this.$refs['my-admin'].show()
    },

    // === 表格相關方法 ===
    checkrow(record) {
      return record.expanded ? "disabled-row" : ""     
    },

    // === API 調用方法 ===
    fetch(params = {}) {
      querymenber({
        ...params,
      }).then(({ data }) => {
        this.items = data   
        for (var obj in this.items.data) {
          if (this.items.data[obj].master == 'Y') { 
            this.cmaster = this.items.data[obj].id
          }
        }               
      });
    }, 
    
    fetch2(params = {}) {
      queryfucntion({
        ...params,
      }).then(({ data }) => {
        this.funarry = data       
      })
    },

    uhandleTableChange(pagination, filters, sorter) {
      const pager = { ...this.upagination };
      pager.current = pagination.current;
      this.upagination = pager;
      
      this.usfetch({
        results: pagination.pageSize,
        page: pagination.current,
        name: this.name,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    }, 
    
    usfetch(params = {}) { 
      this.uloading = true;
      queryuser({
        ...params,
      }).then(({ data }) => {
        const pagination = { ...this.upagination };
        pagination.total = data.info.totail;
        this.uloading = false;
        this.udata = data.results;
        this.upagination = pagination;           
        this.checkman()            
      });
    },     

    // === 保存方法 ===
    save() {
      this.loading = true         
      let group = []
      let list = []
      let resultes = []
      
      for (var j in this.selected) {
        let strs = this.selected[j].split(':')
        group.push(strs[0])
      }
      
      for (var i in this.selected) {
        let str = this.selected[i].split(':')            
        list.push({ id: str[0], fid: str[1] })
      }

      group = group.filter((c, index) => {
        return group.indexOf(c) === index;
      }); 
      
      for (var s in group) {
        let rs = this.items.data[0].permissions.find(item => item.id == group[s])
        let ddata = []
        
        for (var m in list) {
          if (list[m].id == group[s]) {
            ddata.push(list[m])
          }
        }
        
        let detail = []
        for (var k in ddata) {                
          let xs = this.items.data[0].permissions.find(item => item.id == group[s]).acts_detailpermission.find(odata => odata.id == ddata[k].fid)               
          let dtails = {
            id: xs.id,
            seq: xs.seq,
            title: xs.title,
            vals: xs.vals
          }
          detail.push(dtails)
        }
        
        let obj = {
          id: rs.id,
          seq: rs.seq,
          title: rs.title,
          vals: rs.vals,
          icon: rs.icon,
          states: rs.states,
          acts_detailpermission: detail
        } 
        resultes.push(obj)         
      }

      let tmp = {
        orgid: this.defaultval.id,          
        useid: this.form.uid,
        master: 'N',
        modes: 'Y',
        permissions: resultes
      }         
      
      postorgman(tmp).then(({ data }) => {
        if (data.code == 200) {
          this.showTop = true;
          setTimeout(() => {   
            this.current = 0 
            this.loading = false                        
            this.showTop = false
            this.selectedRowKeys = []
            this.selected = []
            this.steps[0].state = false
            this.steps[1].state = false
            this.inid()
            this.$refs['my-loadingx'].hide()
            clearInterval();
          }, 2000);                            
        }
      }); 
    },
    
    save2() {
      this.loading2 = true         
      let group = []
      let list = []
      let resultes = []
      
      for (var j in this.selectedm) {
        let strs = this.selectedm[j].split(':')
        group.push(strs[0])
      }
      
      for (var i in this.selectedm) {
        let str = this.selectedm[i].split(':')            
        list.push({ id: str[0], fid: str[1] })
      }

      group = group.filter((c, index) => {
        return group.indexOf(c) === index;
      }); 
      
      for (var s in group) {
        let rs = this.items.data[0].permissions.find(item => item.vals == group[s])
        let ddata = []
        
        for (var m in list) {
          if (list[m].id == group[s]) {
            ddata.push(list[m])
          }
        }
        
        let detail = []
        for (var k in ddata) {                
          let xs = this.items.data[0].permissions.find(item => item.vals == group[s]).acts_detailpermission.find(odata => odata.vals == ddata[k].fid)               
          let dtails = {
            id: xs.id,
            seq: xs.seq,
            title: xs.title,
            vals: xs.vals
          }
          detail.push(dtails)
        }
        
        let obj = {
          id: rs.id,
          seq: rs.seq,
          title: rs.title,
          vals: rs.vals,
          icon: rs.icon,
          states: rs.states,
          acts_detailpermission: detail
        } 
        resultes.push(obj)         
      }

      let tmp = {
        orgid: this.defaultval.id,          
        useid: this.usdata.uid,
        master: 'N',
        modes: 'Y',
        permissions: resultes
      }         
      
      updateorgman(tmp).then(({ data }) => {
        if (data.code == 200) {
          this.showTop = true;
          setTimeout(() => {   
            this.loading2 = false                        
            this.showTop = false
            this.inid()
            this.$refs['my-loadingm'].hide()
            clearInterval();
          }, 2000);                            
        }
      });       
    },    

    // === 刪除方法 ===
    remove() {        
      this.loading2 = true;        
      deleteorgman(this.usdata).then(({ data }) => { 
        if (data.code == 200) {
          this.showTop = true;
          setTimeout(() => {   
            this.loading2 = false                        
            this.showTop = false
            this.inid()
            this.$refs['my-loadingm'].hide()
            clearInterval();
          }, 2000);                            
        }
      });        
    },

    // === 取消方法 ===
    cancel() {
      this.$refs['my-loadingx'].hide()
    },

    cancel2() {
      this.$refs['my-loadingm'].hide()
    }, 
    
    cancel3() {
      this.$refs['my-admin'].hide()
    },       

    // === 步驟控制方法 ===
    next() {
      this.current++;
    },
    
    prev() {
      this.current--;
    },  
    
    // === 管理員更新方法 ===
    async updateAdmin() {
      if (this.selectedValue !== null) {
        await putOrgAdmin({ oid: this.selectedItems.fid, id: this.selectedValue }).then(({ data }) => {
          if (data.code == 200) {
            // 更新當前 master 為 'N'
            const currentMasterIndex = this.items.data.findIndex(data => data.master === 'Y');
            if (currentMasterIndex !== -1) {
              this.$set(this.items.data, currentMasterIndex, {
                ...this.items.data[currentMasterIndex],
                master: 'N'
              });
            }

            // 更新選中的項目為 'Y'
            const newMasterIndex = this.items.data.findIndex(data => data.id === this.selectedValue);
            if (newMasterIndex !== -1) {
              this.$set(this.items.data, newMasterIndex, {
                ...this.items.data[newMasterIndex],
                master: 'Y'
              });
            }
            this.$refs['my-admin'].hide()                           
          }
        });         
      }
    },

    // === 選擇相關方法 ===
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      let rs = this.udata.filter((el) => { 
        return el.id === selectedRowKeys[0]
      }); 
      
      this.form.name = rs[0].username == '' ? rs[0].display_name : rs[0].username   
      this.form.url = rs[0].pri_url  
      this.form.uid = selectedRowKeys[0]
      this.form.id = rs[0].id 
      
      let newArray = this.items.data.filter(function (el) {
        return el.uid === selectedRowKeys[0];
      });
      
      if (newArray.length === 0) {
        this.steps[0].state = true
      } else {
        this.steps[0].state = false
      }
    },  

    // === 其他方法 ===
    onReset(event) {
      event.preventDefault()
      this.$nextTick(() => {
        // 重置邏輯
      })
    },  
 
    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    }, 
    
    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    }, 
        
    async onSearch(value) {
      if (value == "") {
        this.name = "all"
      } else {
        this.name = value
      }
      await this.usfetch({ results: 4, page: 1, pageSize: 4, name: this.name });
    },

    // === 新增權限相關方法 ===
    // 全選所有權限
    selectAll() {
      this.selected = [];
      this.items.data[0].permissions.forEach(group => {
        group.acts_detailpermission.forEach(permission => {
          this.selected.push(`${group.id}:${permission.id}`);
        });
      });
    },

    // 清除所有選擇
    clearAll() {
      this.selected = [];
    },

    // 選擇整個組別
    selectGroup(group) {
      // 先移除該組的所有選項
      this.selected = this.selected.filter(item => !item.startsWith(`${group.id}:`));
      
      // 添加該組的所有權限
      group.acts_detailpermission.forEach(permission => {
        this.selected.push(`${group.id}:${permission.id}`);
      });
    },

    // 清除整個組別
    clearGroup(group) {
      this.selected = this.selected.filter(item => !item.startsWith(`${group.id}:`));
    },

    // 切換單個權限
    togglePermission(groupId, permissionId) {
      const value = `${groupId}:${permissionId}`;
      const index = this.selected.indexOf(value);
      
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(value);
      }
    },

    // 檢查權限是否被選中
    isPermissionSelected(groupId, permissionId) {
      return this.selected.includes(`${groupId}:${permissionId}`);
    },

    // 檢查組別是否完全被選中
    isGroupFullySelected(group) {
      return group.acts_detailpermission.every(permission => 
        this.selected.includes(`${group.id}:${permission.id}`)
      );
    },

    // 檢查組別是否部分被選中
    isGroupPartiallySelected(group) {
      return group.acts_detailpermission.some(permission => 
        this.selected.includes(`${group.id}:${permission.id}`)
      );
    },

    // 移除選中項目
    removeSelectedItem(value) {
      const index = this.selected.indexOf(value);
      if (index > -1) {
        this.selected.splice(index, 1);
      }
    },

    // 獲取選擇摘要
    getSelectedSummary() {
      const summary = [];
      this.selected.forEach(item => {
        const [groupId, permissionId] = item.split(':');
        const group = this.items.data[0].permissions.find(g => g.id === groupId);
        const permission = group?.acts_detailpermission.find(p => p.id === permissionId);
        
        if (group && permission) {
          summary.push({
            label: `${group.title} - ${permission.title}`,
            value: item
          });
        }
      });
      return summary;
    },
    
    // === 修改權限相關方法 ===
    // 全選所有權限 (修改版)
    selectAllM() {
      this.selectedm = [];
      this.uitem.permissions.forEach(group => {
        group.acts_detailpermission.forEach(permission => {
          this.selectedm.push(`${group.vals}:${permission.vals}`);
        });
      });
    },

    // 清除所有選擇 (修改版)
    clearAllM() {
      this.selectedm = [];
    },

    // 選擇整個組別 (修改版)
    selectGroupM(group) {
      // 先移除該組的所有選項
      this.selectedm = this.selectedm.filter(item => !item.startsWith(`${group.vals}:`));
      
      // 添加該組的所有權限
      group.acts_detailpermission.forEach(permission => {
        this.selectedm.push(`${group.vals}:${permission.vals}`);
      });
    },

    // 清除整個組別 (修改版)
    clearGroupM(group) {
      this.selectedm = this.selectedm.filter(item => !item.startsWith(`${group.vals}:`));
    },

    // 切換單個權限 (修改版)
    togglePermissionM(groupVals, permissionVals) {
      const value = `${groupVals}:${permissionVals}`;
      const index = this.selectedm.indexOf(value);
      
      if (index > -1) {
        this.selectedm.splice(index, 1);
      } else {
        this.selectedm.push(value);
      }
    },

    // 檢查權限是否被選中 (修改版)
    isPermissionSelectedM(groupVals, permissionVals) {
      return this.selectedm.includes(`${groupVals}:${permissionVals}`);
    },

    // 檢查組別是否完全被選中 (修改版)
    isGroupFullySelectedM(group) {
      return group.acts_detailpermission.every(permission => 
        this.selectedm.includes(`${group.vals}:${permission.vals}`)
      );
    },

    // 檢查組別是否部分被選中 (修改版)
    isGroupPartiallySelectedM(group) {
      return group.acts_detailpermission.some(permission => 
        this.selectedm.includes(`${group.vals}:${permission.vals}`)
      );
    },

    // 移除選中項目 (修改版)
    removeSelectedItemM(value) {
      const index = this.selectedm.indexOf(value);
      if (index > -1) {
        this.selectedm.splice(index, 1);
      }
    },

    // 獲取選擇摘要 (修改版)
    getSelectedSummaryM() {
      const summary = [];
      this.selectedm.forEach(item => {
        const [groupVals, permissionVals] = item.split(':');
        const group = this.uitem.permissions.find(g => g.vals === groupVals);
        const permission = group?.acts_detailpermission.find(p => p.vals === permissionVals);
        
        if (group && permission) {
          summary.push({
            label: `${group.title} - ${permission.title}`,
            value: item
          });
        }
      });
      return summary;
    }
  },
};
</script>

<style>
/* 滾動條樣式 */
#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #535151;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #535151;
}

/* 通用樣式 */
.divhidden {
  visibility: hidden;
}

.frams {
  cursor: pointer;
  width: 685px;
  height: 230px;
  background-color: #bdcbe2;
  border-style: dotted;
  border-width: 2px;
  border-radius: 17px;
  border-color: #385e97;
}

.disabled-row {
  background-color: #f1de6e;
  pointer-events: none;
}

.checkboxcss {
  background-color: #f0f2f5;
  margin: 6px;
  padding: 5px;
  border-style: dotted;
  border-width: 1px;
  border-color: #d0d2d5;
}

.overflow-auto {
  overflow-y: auto;
}

/* 單選按鈕組樣式 */
.radio-group {
  display: flex;
  flex-direction: column;
}

.item-container {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.avatar {
  margin-right: 10px;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.displayname {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.radio-button {
  display: flex;
  align-items: center;
}

.cssSelected {
  font-size: 16px;
  font-weight: bold;
  padding-top: 0.28rem;
  background: linear-gradient(-45deg, #ffffff, #73bcda, #bfe7f7);
}

.cssUnSelected {
  font-size: 15px;
  padding-top: 0.28rem;
  background: linear-gradient(-45deg, #ffffff, #d8edf5, #ffffff);
}

/* 權限容器樣式 */
.permissions-container {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

/* 全局控制 */
.global-controls {
  margin-bottom: 24px;
}

.control-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.control-header h4 {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
}

.global-buttons {
  display: flex;
  gap: 8px;
}

/* 權限組別 */
.permission-group {
  margin-bottom: 20px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #dee2e6;
}

.group-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-icon {
  color: #1890ff;
  font-size: 18px;
}

.group-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.group-controls {
  display: flex;
  gap: 8px;
}

/* 權限網格 */
.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
  padding: 20px;
}

/* 權限項目 */
.permission-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.permission-item:hover {
  border-color: #1890ff;
  background: #f0f7ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.1);
}

.permission-item.selected {
  border-color: #1890ff;
  background: #e6f7ff;
}

.permission-checkbox {
  flex-shrink: 0;
}

.permission-content {
  flex: 1;
  min-width: 0;
}

.permission-title {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 4px;
  word-break: break-word;
}

.permission-description {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.3;
}

.permission-icon {
  flex-shrink: 0;
  font-size: 18px;
  color: #d0d0d0;
  transition: all 0.3s ease;
}

.selected-icon {
  color: #1890ff !important;
}

/* 選擇摘要 */
.selection-summary {
  margin-top: 20px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #2c3e50;
}

.summary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .control-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .group-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .permissions-grid {
    grid-template-columns: 1fr;
  }

  .permission-item {
    padding: 16px;
  }

  .summary-tags {
    flex-direction: column;
  }
}

@media (max-width: 576px) {
  .permissions-container {
    padding: 12px;
  }

  .permissions-grid {
    padding: 16px;
    gap: 8px;
  }

  .permission-item {
    padding: 12px;
  }
}
</style>